import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rdx_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (token && config.url && config.url.startsWith("/auth")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: Number(n) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

export const errMsg = (e, fallback = "Ocurrió un error") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const youtubeId = (url = "") => {
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : null;
};

// Direct signed upload to Cloudinary (persistent CDN storage)
// target: "admin" (images/videos, requires admin token) | "review" (public, images only)
export async function uploadFile(file, onProgress, target = "admin") {
  const sigUrl = target === "review" ? "/reviews/upload-signature" : "/admin/upload-signature";
  const { data: sig } = await api.get(sigUrl);
  const fd = new FormData();
  fd.append("file", file);
  fd.append("api_key", sig.api_key);
  fd.append("timestamp", String(sig.timestamp));
  fd.append("signature", sig.signature);
  fd.append("folder", sig.folder);
  if (sig.allowed_formats) fd.append("allowed_formats", sig.allowed_formats);
  const resourceType = target === "review" ? "image" : "auto";
  try {
    const { data } = await axios.post(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resourceType}/upload`, fd, {
      onUploadProgress: (e) => e.total && onProgress && onProgress(Math.round((e.loaded / e.total) * 100)),
    });
    return data.secure_url;
  } catch (e) {
    const msg = e?.response?.data?.error?.message;
    const err = new Error(msg || "Upload failed");
    err.response = { data: { detail: msg ? `Error al subir: ${msg}` : "Error al subir el archivo" } };
    throw err;
  }
}
